import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import { compareAsc, format, addMonths, isValid } from "date-fns";
import moment from "moment";
import Skills from "./Skills/Skills";
import { httpCreateUserGroup } from "./Skills/api/calls";
import DatePicker from "react-datepicker";
import {
  httpCreateSubSkill,
  getSkillByDeptID,
} from "../HR/Skills/subSkills/api/calls";
import { httpCreateGroup } from "../HR/Skills/SkillGroup/api/calls";
import Select from "react-select";
// import { Modal } from "antd";

let reporting_option = [];
let finalreport_option = [];
function AddEmployeeCom() {
  const salutationRef = useRef();
  const fnameRef = useRef();
  const peremailRef = useRef();
  const timezoneRef = useRef();
  const dobRef = useRef();
  const companyRef = useRef();
  const divisionRef = useRef();
  const deptRef = useRef();
  const dofjRef = useRef();
  const designationjRef = useRef();
  const empcatRef = useRef();
  const empshiftRef = useRef();
  const systemRoleRef = useRef();
  const newworklocationRef = useRef();
  const skillRef = useRef();
  const appointmentLetterRef = useRef(null);
  const relavingLetterRef = useRef(null);

  let navigate = useNavigate();
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));

  const [skillData, setUserSkillData] = useState([]);

  const [salutation, setSalutation] = useState("");
  const [fname, setFname] = useState("");
  const [mname, setMname] = useState("");
  const [lname, setLname] = useState("");
  const [gargen, setGargen] = useState("");
  const [gender, setGender] = useState("");
  const [dateofbirth, setDateofbirth] = useState("");
  const [marriage, setMarriage] = useState("");
  const [bloodgroup, setBloodgroup] = useState("");
  const [nationality, setNationality] = useState("");
  // const [adhaarname, setAdhaarname] = useState('');
  const [adhaarnumber, setAdhaarnumber] = useState("");
  const [pancardnumber, setPancardnumber] = useState("");
  const [company, setCompany] = useState("");
  const [division, setDivision] = useState("");
  const [department, setDepartment] = useState("");

  // const [empcode, setEmpcode] = useState('');
  const [empstatus, setEmpstatus] = useState("");
  const [dateofjoining, setDateofjoining] = useState("");
  const [probation_period, setProbation_period] = useState("");
  const [confirmationdate, setConfirmationdate] = useState("");

  const [designation, setDesignation] = useState("");
  const [empcategory, setEmpcategory] = useState("");
  const [noticeperiod, setNoticeperiod] = useState("");

  const [salaryType, setSalaryType] = useState("");
  const [ctc, setCtc] = useState("");
  const [bankname, setBankname] = useState("");
  const [accountnumber, setAccountnumber] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [pfapplicable, setPfapplicable] = useState("");
  const [pfnumber, setPfnumber] = useState("");
  const [pfgroup, setPfgroup] = useState("");
  const [uan_number, setUan_number] = useState("");
  // const [pt_applicable, setPt_applicable] = useState('');

  const [role, setRole] = useState("");
  const [depdata, setDepdata] = useState([]);
  const [roledata, setRoledata] = useState([]);
  const [comdata, setComdata] = useState([]);

  const [color, setColor] = useState("");
  const [errmsg, setErrmsg] = useState("");
  const [buttonstatus, setbuttonstatus] = useState(true);
  const [persona_email, setPersonal_email] = useState("");
  const [altemail, setAltemail] = useState("");
  const [contact_number, setContact_number] = useState("");
  const [timezone, setTimezone] = useState("");
  // const [officialemailstatus, setOfficialemailstatus] = useState(true);

  const [err, setErr] = useState("");
  const [errMsgsalutaion, setErrMsgsalutaion] = useState("");
  const [errMsgfname, setErrMsgfname] = useState("");
  const [errMsgpersona_email, setErrMsgpersona_email] = useState("");
  const [errMsgTimezone, setErrMsgTimezone] = useState("");
  const [errMsgdateofbirth, setErrMsgdateofbirth] = useState("");
  const [errMsgsysRole, setErrMsgsysRole] = useState("");
  const [errMsgcompany, setErrMsgcompany] = useState("");
  const [errMsgdivision, setErrMsgdivision] = useState("");
  const [errMsgdepartment, setErrMsgdepartment] = useState("");
  const [errMsgdateofjoining, setErrMsgdateofjoining] = useState("");
  const [errMsgdesignation, setErrMsgdesignation] = useState("");
  const [errMsgempcat, setErrMsgempcat] = useState("");
  const [errMsgShift, setErrMsgShift] = useState("");
  const [reportingmanager, setreportingmanager] = useState("");
  const [finalReport, setFinalReport] = useState("");
  const [systemRole, setSystemRole] = useState("");
  const [shift, setShift] = useState("");
  const [workplace, setWorkplace] = useState("");
  const [countrycode, setCountrycode] = useState("");
  const [shiftList, setShiftList] = useState([]);
  const [complist, setComplist] = useState([]);
  const [countrylist, setCountrylist] = useState([]);
  const [system_role, setSystem_role] = useState([]);
  const [CountryINWish, setIsHiddenIndia] = useState("");
  const [country, setCountry] = useState("");
  const [hobbies, setHobbies] = useState("");
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");

  const [emercontactpersion, setEmercontactpersion] = useState("");
  const [emercontactnumber, setEmercontactnumber] = useState("");
  const [emercontactrelation, setEmercontactrelation] = useState("");
  const [currenAdd, setcurrenAdd] = useState("");
  const [permanentaddress, setPermanentaddress] = useState("");
  const [dateofwedding, setDateofwedding] = useState("");
  const [computerSkills, setComputerSkills] = useState("");
  const [otherSkills, setOtherSkills] = useState("");

  // for language
  const [speak1, setSpeak1] = useState("");
  const [speak2, setSpeak2] = useState("");
  const [write1, setWrite1] = useState("");
  const [write2, setWrite2] = useState("");
  const [read1, setRead1] = useState("");
  const [read2, setRead2] = useState("");
  const [understand1, setUnderstand1] = useState("");
  const [understand2, setUnderstand2] = useState("");
  const [modal, setModal] = useState(false);
  useEffect(() => {
    getCompanyList();
    getDepartmentList();
    getReportingManager();
    getShiftList();
    getCountryList();
    getSystemRole();
    //getmaxUserId();
  }, []);

  const [empCode, setEmpCode] = useState("");
  const [emp_code, setEmp_code] = useState("");
  const getmaxUserId = () => {
    const response = fetch(SERVER_URL + `api/common/getmaxuserid`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        var maxId = data?.result?.max_id ? data?.result?.max_id + 1 : "";
        setEmp_code(maxId);
        setEmpCode(maxId);
      });
  };

  const getSystemRole = () => {
    const response = fetch(SERVER_URL + `api/common/sytem-role`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSystem_role(data.result);
      });
  };
  const getCountryList = () => {
    const response = fetch(SERVER_URL + `api/common/country_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setComplist(data.result);
          setCountrylist(data.result);
        }
      });
  };
  const getShiftList = () => {
    const response = fetch(SERVER_URL + `api/common/getshiftlist`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        emailpersonal: persona_email,
        city: "",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setShiftList(data.result);
      });
  };
  const [reportimgManageList, setReportimgManageList] = useState([]);
  const [finalReportList, setFinalReportList] = useState([]);
  const getReportingManager = () => {
    const response = fetch(SERVER_URL + `api/common/manager_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setReportimgManageList(data.result);
        setFinalReportList(data.result);
        reporting_option = [];
        finalreport_option = [];
        data?.result.map((row) => {
          reporting_option.push({
            value: row.id,
            label: row.name + " (" + row.user_code + ")",
          });
          finalreport_option.push({
            value: row.id,
            label: row.name + " (" + row.user_code + ")",
          });
        });
      });
  };

  const getCompanyList = () => {
    const response = fetch(SERVER_URL + `api/common/company_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setComdata(data.result);
      });
  };
  const getDepartmentList = () => {
    const response = fetch(SERVER_URL + `api/common/department_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setDepdata(data.result);
      });
  };
  function handleChange(deptid) {
    setDepartment(deptid);
    if (deptid == "") {
      return false;
    } else {
      const response = fetch(SERVER_URL + `api/common/get_department_role`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
        body: JSON.stringify({
          id: deptid,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setRoledata(data.result);
        });
    }
  }
  const userSkillParentCallback = (userSkillChildData) => {
    setUserSkillData(userSkillChildData);
  };
  const [errSkill, setErrSkill] = useState("");
  const handleAddEMP = () => {
    var usernameRegex = /^([a-zA-Z0-9](_|-| )[a-zA-Z0-9])*[a-zA-Z0-9]+$/;
    let regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    setErrMsgsalutaion("");
    setErrMsgfname("");
    setErrMsgpersona_email("");
    setErrMsgdateofbirth("");
    setErrMsgsysRole("");
    setErrMsgcompany("");
    setErrMsgdivision("");
    setErrMsgdepartment("");
    setErrMsgdateofjoining("");
    setErrMsgdesignation("");
    setErrMsgempcat("");
    setErr("");
    setErrSkill("");
    setErrdesignation("");
    setErrrole("");
    setEmp_profile(0);
    setEmp_spc(0);
    setEmp_dtl(0);
    if (company == "" || company == null || company == undefined) {
      setEmp_profile(1);
      setErr("red");
      setErrMsgcompany("red");
      companyRef.current.focus();
      return false;
    } else if (
      department == "" ||
      department == null ||
      department == undefined ||
      deptRef.current == "" ||
      deptRef.current == null
    ) {
      setEmp_profile(1);
      // setErr('red')
      setErrrole("red");
      deptRef?.current?.focus();
      return false;
    } else if (
      designation == "" ||
      designation == null ||
      designation == undefined ||
      designationjRef.current == "" ||
      designationjRef.current == null
    ) {
      setSub_dept_status("block");
      setEmp_profile(1);
      // setErr('red')
      setErrdesignation("red");
      designationjRef?.current?.focus();
      return false;
    } else if (
      skill == "" ||
      skill == null ||
      skill == undefined ||
      skillRef.current == "" ||
      skillRef.current == null
    ) {
      setEmp_profile(1);
      setErrSkill("red");
      setSkill_status("block");
      skillRef?.current?.focus();
      return false;
    } else if (
      empcategory == "" ||
      empcategory == null ||
      empcategory == undefined
    ) {
      setEmp_profile(1);
      setErr("red");
      setErrMsgempcat("red");
      empcatRef.current.focus();
      return false;
    } else if (
      systemRole == "" ||
      systemRole == null ||
      systemRole == undefined
    ) {
      setEmp_profile(1);
      setErr("red");
      setErrMsgsysRole("red");
      systemRoleRef.current.focus();
      return false;
    } else if (
      salutation == "" ||
      salutation == null ||
      salutation == undefined
    ) {
      setEmp_profile(1);
      setErr("red");
      setErrMsgsalutaion("red");
      salutationRef.current.focus();
      return false;
    } else if (!usernameRegex.test(fname)) {
      setEmp_profile(1);
      setErr("red");
      setErrMsgfname("red");
      fnameRef.current.focus();
      return false;
    } else if (!regEmail.test(persona_email)) {
      setEmp_profile(1);
      setErr("red");
      setErrMsgpersona_email("red");
      peremailRef.current.focus();
      return false;
    } else if (timezone == "" || timezone == null || timezone == undefined) {
      setEmp_profile(1);
      setErr("red");
      setErrMsgTimezone("red");
      timezoneRef.current.focus();
      return false;
    } else if (shift == "" || shift == null || shift == undefined) {
      setEmp_profile(1);
      setErr("red");
      setErrMsgShift("red");
      empshiftRef.current.focus();
      return false;
    } else if (
      (dateofbirth == "" || dateofbirth == null || dateofbirth == undefined) &&
      company == 1
    ) {
      setEmp_profile(1);
      setErr("red");
      setErrMsgdateofbirth("red");
      dobRef.current.focus();
      return false;
    }
    // no change
    // else if (division == '') {
    // 	setEmp_spc(1)
    // 	setErr('red')
    // 	setErrMsgdivision('This field is required')
    // 	divisionRef.current.focus();
    // 	return false;
    // }
    // no change
    else if (empcategory == "") {
      setEmp_spc(1);
      setErr("red");
      setErrMsgempcat("This field is required");
      empcatRef.current.focus();
      return false;
    }

    // no change
    // else if (department == '') {
    // 	setEmp_spc(1)
    // 	setErr('red')
    // 	setErrMsgdepartment('This field is required')
    // 	deptRef.current.focus();
    // 	return false;
    // }
    // no change
    else if (dateofjoining == "") {
      setEmp_spc(1);
      setErr("red");
      setErrMsgdateofjoining("red");
      dofjRef.current.focus();
      return false;
    } else {
      const date = new Date();
      const date_formate = format(date, "yyyy-MM-dd HH:m:ss");
      const userId = localStorage.getItem("userId");

      const formData = new FormData();
      formData.append("comp", company);
      formData.append("division", department);
      formData.append("deprt", designation);
      formData.append("skill", skill);
      formData.append("empcategory", empcategory);
      formData.append("systemRole", systemRole);
      formData.append("salutation", salutation);
      formData.append("fname", fname);
      formData.append("mname", mname);
      formData.append("lname", lname);
      formData.append("emailpersonal", persona_email ? persona_email : "");
      formData.append("alrtemail", altemail ? altemail : "");
      formData.append("contact", contact_number);
      formData.append("gurgaon", gargen);
      formData.append("hobbies", hobbies);
      formData.append("weight", weight);
      formData.append("height", height);
      formData.append("nationality", nationality);
      formData.append("country", country);
      formData.append("timezone", timezone);
      formData.append("state", state ? state : "");
      formData.append("workplace", workplace ? workplace : "");
      formData.append("city", "");
      formData.append("emercontactpersion", emercontactpersion);
      formData.append("emercontactnumber", emercontactnumber);
      formData.append("emercontactrelation", emercontactrelation);
      formData.append("currenAdd", currenAdd);
      formData.append("permanentaddress", permanentaddress);
      formData.append("status", empstatus);
      formData.append("pancardnumber", pancardnumber);
      formData.append("adhaarnumber", adhaarnumber);
      formData.append("empcode", empCode);
      formData.append("joiningdate", dateofjoining);
      formData.append("probation_period", probation_period);
      formData.append("confirmationdate", confirmationdate);
      formData.append("pincode", "");
      formData.append("noticeperiod", noticeperiod);
      formData.append("salaryType", salaryType);
      formData.append("ctc", ctc);
      formData.append("bankname", bankname);
      formData.append("accountnumber", accountnumber);
      formData.append("ifsc", ifsc);
      formData.append("pfnumber", pfnumber);
      formData.append("pfgroup", pfgroup);
      formData.append("uan_number", uan_number);
      formData.append("created_on", date_formate);
      formData.append("created_by", userId);
      formData.append("reporting_manager", reportingmanager);
      formData.append("finalreporting", finalReport);
      formData.append("country_code", countrycode);
      formData.append("gender", gender);
      // formData.append("dateofbirth", dateofbirth ? dateofbirth : "0000:00:00");

      if (dateofbirth) {
        formData.append(
          "dateofbirth",
          new Date(dateofbirth).toISOString().split("T")[0], // YYYY-MM-DD
        );
      } else {
        formData.append("dateofbirth", null);
      }

      formData.append("marriage", marriage);
      // formData.append("marriageDate", marriage == 1 ? dateofwedding : "");

      if (marriage === 1 && dateofwedding) {
        formData.append(
          "marriageDate",
          new Date(dateofwedding).toISOString().split("T")[0], // YYYY-MM-DD
        );
      } else {
        formData.append("marriageDate", "");
      }

      formData.append("bloodgroup", bloodgroup);
      // formData.append("height", height);
      // formData.append("weight", weight);
      formData.append("shift", shift);
      formData.append("computerSkills", computerSkills);
      formData.append("otherSkills", otherSkills);
      formData.append("speak1", speak1);
      formData.append("speak2", speak2);
      formData.append("read1", read1);
      formData.append("read2", read2);
      formData.append("write1", write1);
      formData.append("write2", write2);

      formData.append("understand1", understand1);
      formData.append("understand2", understand2);
      formData.append("aadharcard", uploadaadharcard);
      formData.append("pancard", uploadpancard);
      formData.append("addressproof", uploadaddressproof);
      formData.append("photograph", uploadphotograph);
      formData.append("uploadpassport", uploadpassport);
      formData.append("empslipfile1", empslipfile1);
      formData.append("empslipfile2", empslipfile2);
      formData.append("empslipfile3", empslipfile3);

      formData.append(
        "addmorerecordfamily",
        JSON.stringify(addmorerecordfamily),
      );
      formData.append(
        "addmorequalification",
        JSON.stringify(addmorequalification),
      );
      formData.append("empExp", JSON.stringify(empExp));

      if (addmorequalification.length > 0) {
        addmorequalification?.map((qlf, ind) => {
          formData.append(`qlf_doc_${qlf.unic_number}`, qlf.insdocument);
        });
      }

      if (empExp.length > 0) {
        empExp?.map((employment, ind) => {
          formData.append(
            `reliving_doc_${employment.unic_number}`,
            employment.uploadedRelivingLetter,
          );
          formData.append(
            `uppointment_doc_${employment.unic_number}`,
            employment.uploadedUppointmentLetter,
          );
        });
      }

      const response = fetch(SERVER_URL + `api/employee/add`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token.value}`,
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            addUserSkill(data.lastID);
            setErrmsg("Employee, Successfully Added");
            setColor("green");
            setTimeout(function () {
              navigate("/employeelist");
            }, 1000);
          } else {
            setErrmsg("Error! Something went wrong");
            setColor("red");
          }
        });
    }
    const addUserSkill = (id) => {
      if (skillData) {
        const userSkill = {
          user_id: id,
          skillData,
        };
        httpCreateUserGroup(userSkill);
      }
    };
  };
  // const handleEmail = () => {
  // 	setOfficialemailstatus(!officialemailstatus)
  // }
  const [emp_profile, setEmp_profile] = useState(1);
  const [emp_spc, setEmp_spc] = useState(0);
  const [emp_dtl, setEmp_dtl] = useState(0);

  const [emp_family, setEmp_family] = useState(0);
  const [emp_previous, setEmp_previous] = useState(0);

  const [emp_skill, seEmp_skill] = useState(0);
  const handleTab = (tab_id) => {
    setEmp_profile(0);
    setEmp_spc(0);
    setEmp_dtl(0);
    seEmp_skill(0);
    setEmp_family(0);
    setEmp_previous(0);

    if (tab_id == 1) {
      setEmp_profile(tab_id);
    } else if (tab_id == 2) {
      setEmp_spc(tab_id);
    } else if (tab_id == 3) {
      setEmp_dtl(tab_id);
    } else if (tab_id == 4) {
      setEmp_family(tab_id);
    } else if (tab_id == 5) {
      setEmp_previous(tab_id);
    }
  };
  const [locationlist, setLocationlist] = useState([]);

  const getLocation = async (id) => {
    const response = await fetch(
      SERVER_URL + `api/common/time-zone-list?countryId=${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setLocationlist(data.result);
        }
      });
  };
  const [workLocationlist, setWorkLocationlist] = useState([]);
  const getWorkLocation = async (state) => {
    const response = await fetch(
      SERVER_URL + `api/common/getworkLocation?stateid=${state}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setWorkLocationlist(data.result);
        }
      });
  };
  const handleDepartment = (val) => {
    setDepartment(val);
    setSkillList([]);
    getSkillByDeptID(val).then((res) => {
      if (res.status) {
        setRoledata(res.data);
      }
    });
  };

  const [sub_dept_status, setSub_dept_status] = useState("block");
  const handleAddSubRole = () => {
    setSub_dept_status(sub_dept_status == "block" ? "none" : "block");
  };
  const [errrole, setErrrole] = useState("");
  const [errsubrole, setErrsubrole] = useState("");
  const [newSubrole, setNewSubrole] = useState("");
  const [sub_role, setSub_Role] = useState("");

  const handleSaveSubRole = () => {
    setErrrole("");
    setErrsubrole("");
    if (department == "") {
      setErrrole("red");
      return false;
    }
    if (newSubrole == "") {
      setErrsubrole("red");
      return false;
    } else {
      check_department(department, newSubrole);
      //add_new_sub_role(department, newSubrole)
    }
  };

  const [errcheckrole, setErrcheckrole] = useState("");
  const check_department = (department, newSubrole) => {
    setErrcheckrole("");
    setErrsubrole("");
    const response = fetch(SERVER_URL + `api/common/checkdepartment`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        role: department,
        name: newSubrole,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          if (data?.result.total > 0) {
            setErrcheckrole("Already exists");
            setErrsubrole("red");

            return false;
          } else {
            add_new_sub_role(department, newSubrole);
          }
        }
      });
  };

  const add_new_sub_role = (department, newSubrole) => {
    const user_login_id = localStorage.getItem("userId");
    const date = new Date();
    const date_formate = format(date, "yyyy-MM-dd HH:m:SS");
    const response = fetch(SERVER_URL + `api/common/add_department`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        role: department,
        name: newSubrole,
        code: "",
        created_on: date_formate,
        created_by: user_login_id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setDepartment(department);
          //handleChange(department)
          setSub_dept_status("block");
          setSub_Role("");

          setNewSubrole("");
          getSkillByDeptID(department).then((res) => {
            if (res.status) {
              setRoledata(res.data);
            }
          });
        }
      });
  };
  const handleCancelSubRole = () => {
    setNewSubrole("");
    setSub_dept_status(sub_dept_status == "none" ? "block" : "none");
    setErrcheckrole("");
    setErrsubrole("");
  };

  const [newworklocation, setNewworklocation] = useState("");
  const [location_status, setLocation_status] = useState("block");
  const handleWorkLocation = () => {
    setLocation_status(location_status == "none" ? "block" : "none");
  };
  const handleCancellocation = () => {
    setLocation_status(location_status == "none" ? "block" : "none");
    setNewworklocation("");
  };
  const [errwrklsn, setErrwrklsn] = useState("");
  const [errstate, setErrstate] = useState("");
  const handleSaveLocation = () => {
    setErrwrklsn("");
    setErrstate("");
    const user_login_id = localStorage.getItem("userId");
    const date = new Date();
    const date_formate = format(date, "yyyy-MM-dd HH:m:SS");
    if (state == "" || state == null || state == undefined) {
      setErrstate("red");
      return false;
    }
    if (newworklocation == "" || newworklocation == null) {
      setErrwrklsn("red");
      newworklocationRef.current.focus();
      return false;
    } else {
      const response = fetch(SERVER_URL + `api/common/add_workLocation`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
        body: JSON.stringify({
          state: state,
          location: newworklocation,
          created_on: date_formate,
          created_by: user_login_id,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status == true) {
            setNewworklocation("");
            setLocation_status("block");
            setWorkplace("");
            getWorkLocation(state);
          }
        });
    }
  };

  const handleChangeNumber = (e) => {
    if (!isNaN(Number(e.target.value))) {
      setContact_number(e.target.value);
    }
  };

  const handleDegination = (e) => {
    setDesignation(e.target.value);
    getSkills_list(e.target.value);
  };
  const [skillList, setSkillList] = useState([]);
  const getSkills_list = (id) => {
    const response = fetch(SERVER_URL + `api/common/getSkillsList?id=${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setSkillList(data.data);
        }
      });
  };
  const [skill, setSkill] = useState("");
  const [errskill, setErrskill] = useState("");
  const [errdesignation, setErrdesignation] = useState("");
  const [newSkill, setNewSkill] = useState("");
  const [skill_status, setSkill_status] = useState("block");

  const handleAddSkill = () => {
    setSkill_status(skill_status == "block" ? "none" : "block");
    setNewSubrole("");
    setErrskill("");
    setErrcheckskill("");
  };
  const handleSaveSkill = () => {
    setErrskill("");
    setErrdesignation("");
    if (designation == "" || designation == null || designation == undefined) {
      setErrdesignation("red");
      designationjRef.current.focus();
      return false;
    } else if (newSkill == "" || newSkill == null || newSkill == undefined) {
      setErrskill("red");
      return false;
    } else {
      check_skill(designation, newSkill);
    }
  };

  const [errcheckskill, setErrcheckskill] = useState("");
  const check_skill = (designation, newSkill) => {
    setErrskill("");
    setErrcheckskill("");
    const response = fetch(SERVER_URL + `api/common/checkskill`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        id: designation,
        name: newSkill,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          if (data?.result.total > 0) {
            setErrskill("red");
            setErrcheckskill("Already Exist");
          } else {
            httpCreateSubSkill({ name: newSkill, group_id: designation }).then(
              (res) => {
                if (res.status) {
                  getSkills_list(designation);
                  setSkill_status("block");
                  setNewSkill("");
                }
              },
            );
          }
        }
      });
  };
  const handleCancelSkill = () => {
    setSkill_status(skill_status == "block" ? "none" : "block");
    setNewSkill("");
    setNewSubrole("");
  };

  const [state, setState] = useState("");
  const [statelist, setStatelist] = useState([]);

  const getStateByCID = async (id) => {
    const response = await fetch(
      SERVER_URL + `api/common/state?countryId=${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setStatelist(data.result);
        }
      });
  };
  const handleCountry = (id) => {
    setCountry(id);
    getLocation(id);
    getStateByCID(id);
  };
  const HandleCompany = (e) => {
    setErrMsgcompany("");
    setCompany(e.target.value);

    let cid = "";
    if (e.target.value == 1 || e.target.value == 2) {
      cid = "1";
    }
    if (e.target.value == 3 || e.target.value == 5) {
      cid = "2";
    }
    if (e.target.value == 6) {
      cid = "3";
    }
    handleCountry(cid);
  };
  const HandleState = (e) => {
    setState(e.target.value);
    getWorkLocation(e.target.value);
  };
  useEffect(() => {
    setErrMsgdepartment("");
    setErrMsgdesignation("");
    setErrSkill("");
    setErrMsgempcat("");
    setErrMsgsysRole("");
    setErrMsgsalutaion("");
    setErrMsgTimezone("");
    setErrMsgShift("");
  }, [
    department,
    designation,
    skill,
    empcategory,
    systemRole,
    salutation,
    timezone,
    shift,
  ]);

  const HandleDateOfJoining = (e) => {
    setDateofjoining(e.target.value);
    const period = new Date(e.target.value);
    const end = addMonths(period, 6);

    let confDate = "";
    if (end && isValid(new Date(end))) {
      confDate = format(new Date(end), "yyyy-MM-dd");
    }
    // const confDate = format(end, "yyyy-MM-dd");
    setConfirmationdate(confDate);

    var date1 = new Date(dateofjoining);
    var date2 = new Date(confirmationdate);
    if (dateofjoining) {
      var year1 = date1.getFullYear();
      var year2 = date2.getFullYear();
      var month1 = date1.getMonth();
      var month2 = date2.getMonth();
      const numberOfMonths = (year2 - year1) * 12 + (month2 - month1);
      setProbation_period(numberOfMonths);
    }
  };

  const [save_status, setSave_status] = useState("");
  const [checkemail, setCheckemail] = useState("");
  const HandlePerEmail = (e) => {
    setPersonal_email(e.target.value);
    VerifyEmail(e.target.value);
    setCheckemail("");
    setSave_status("");
  };
  const VerifyEmail = (checkemail) => {
    if (checkemail.includes(".") && checkemail.includes("@")) {
      const response = fetch(
        SERVER_URL + `api/common/checkemail?email=${checkemail}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token.value}`,
          },
        },
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.status == true) {
            if (data?.result?.total > 0) {
              setCheckemail("email already in use");
              setSave_status("disabled");
              return false;
            }
          }
        });
    }
  };

  function monthDiff(dateFrom, dateTo) {}

  const HandleConfirmationDate = (e) => {
    setConfirmationdate(e.target.value);
    var date1 = new Date(dateofjoining);
    var date2 = new Date(confirmationdate);

    if (dateofjoining) {
      var year1 = date1.getFullYear();
      var year2 = date2.getFullYear();
      var month1 = date1.getMonth();
      var month2 = date2.getMonth();
      const numberOfMonths = (year2 - year1) * 12 + (month2 - month1);
      setProbation_period(numberOfMonths);
    }
  };
  const HandleSystemRole = (e) => {
    setSystemRole(e.target.value);
    if (e.target.value == 1) {
      setNoticeperiod("0");
    } else {
      setNoticeperiod("0");
    }
  };
  const HandleAdhaar = (e) => {
    if (!isNaN(Number(e.target.value))) {
      setAdhaarnumber(e.target.value);
    }
  };
  // const HandleEpmCode = (e) => {
  // 	setEmpcode(e.target.value)

  // 	if (e.target.value.length > 2) {
  // 		verifyEmpCode(e.target.value)
  // 	}
  // }
  // const [checkempcode, setCheckempcode] = useState('');
  // const verifyEmpCode = (empCode) => {
  // 	setSave_status('')
  // 	const response = fetch(SERVER_URL + `api/common/check-emp-code`,
  // 		{
  // 			method: 'POST',
  // 			headers: {
  // 				'Accept': 'application/json',
  // 				'Content-Type': 'application/json',
  // 				'authorization': `bearer ${token.value}`
  // 			},
  // 			body: JSON.stringify({
  // 				empCode: empCode,
  // 			})
  // 		}).then(res => res.json()).then(data => {
  // 			if (data.status == true) {
  // 				setCheckempcode(data?.result?.total);
  // 				if (data?.result?.total > 0) {
  // 					setSave_status('disabled')
  // 				}
  // 			}
  // 		})
  // }

  // const handlePayRole = (e) => {
  //   setEmpcategory(e.target.value);
  //   if (e.target.value == 2) {
  //     setEmpCode("C" + emp_code);
  //   } else {
  //     setEmpCode(emp_code);
  //   }
  // };

  const handlePayRole = async (e) => {
    const category = e.target.value;

    setEmpcategory(category);

    try {
      const response = await fetch(
        SERVER_URL + "api/common/employee-code-byType",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token.value}`,
          },
        },
      );

      const data = await response.json();

      if (data.status === true) {
        const { next_contract_code, next_employee_code } = data.result ?? {};

        if (category == 2) {
          setEmpCode(next_contract_code); // e.g. C2391
          setProbation_period(0);
          setNoticeperiod(7);
        } else {
          setEmpCode(next_employee_code); // e.g. 2930
          setProbation_period(6);
          setNoticeperiod(15);
        }
      }
    } catch (error) {
      console.error("Error fetching employee code:", error);
    }
  };
  const [uploadaadharcard, setUploadaadharcard] = useState("");
  const handleAadharCard = (e) => {
    const file = e.target.files[0];
    setUploadaadharcard(file);
  };

  const [uploadpancard, setUploadpancard] = useState("");
  const handlePancard = (e) => {
    const file = e.target.files[0];
    setUploadpancard(file);
  };

  const [uploadaddressproof, setUploadaddressproof] = useState("");
  const handleAddressProof = (e) => {
    const file = e.target.files[0];
    setUploadaddressproof(file);
  };

  const [uploadphotograph, setUploadphotograph] = useState("");
  const handlePhotoGraph = (e) => {
    const file = e.target.files[0];
    setUploadphotograph(file);
  };

  const [uploadpassport, setUploadpassport] = useState("");
  const handlePassportnumber = (e) => {
    const file = e.target.files[0];
    setUploadpassport(file);
  };

  const [addmorerecordfamily, setAddmorerecordfamily] = useState([]);
  const addmorefamilyDetails = () => {
    setErr_familymembername("");
    setErr_familymemberrelation("");
    setErr_familymemberdob("");
    setErr_familymemberaccupation("");

    const regexText = /^[a-zA-Z0-9 ]+$/;
    if (!regexText.test(familymembername.trim())) {
      setErr_familymembername("required");
      return false;
    }
    if (!regexText.test(familymemberrelation.trim())) {
      setErr_familymemberrelation("required");
      return false;
    }
    if (
      familymemberdob == "" ||
      familymemberdob == null ||
      familymemberdob == undefined
    ) {
      setErr_familymemberdob("required");
      return false;
    }
    if (!regexText.test(familymemberaccupation.trim())) {
      setErr_familymemberaccupation("required");
      return false;
    } else {
      const user_login_id = localStorage.getItem("userId");
      const date = new Date();
      const createdDatte = format(date, "yyyy-MM-dd HH:m:SS");
      const newRecord = {
        id: user_login_id,
        name: familymembername,
        age: familymemberage,
        dob: familymemberdob,
        rel: familymemberrelation,
        accupation: familymemberaccupation,
        ctratedOn: createdDatte,
      };
      setAddmorerecordfamily((prevRecords) => [...prevRecords, newRecord]);
      setFamilymembername("");
      setFamilymemberrelation("");
      setFamilymemberdob("");
      setFamilymemberage("");
      setFamilymemberaccupation("");
    }
  };

  const [familymembername, setFamilymembername] = useState("");
  const [err_familymembername, setErr_familymembername] = useState("");

  const [familymemberrelation, setFamilymemberrelation] = useState("");
  const [err_familymemberrelation, setErr_familymemberrelation] = useState("");

  const [familymemberdob, setFamilymemberdob] = useState("");
  const [err_familymemberdob, setErr_familymemberdob] = useState("");

  const [familymemberage, setFamilymemberage] = useState("");
  const [familymemberaccupation, setFamilymemberaccupation] = useState("");
  const [err_familymemberaccupation, setErr_familymemberaccupation] =
    useState("");

  const handleAge = (e) => {
    setFamilymemberdob(e.target.value);
    const age = calculateAge(e.target.value);
    setFamilymemberage(age);
  };
  function calculateAge(dateString) {
    const birthDate = new Date(dateString);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  const removeRecord = (index) => {
    setAddmorerecordfamily((prev) => prev.filter((_, i) => i !== index));
  };

  const handleShowModal = () => {
    setModal(true);
  };
  const handleClose = () => {
    setErr_familymembername("");
    setErr_familymemberrelation("");
    setErr_familymemberdob("");
    setErr_familymemberaccupation("");
    setModal(false);
  };

  const [qualificationmodal, setQualificationmodal] = useState(false);
  const handleShowModalqualification = () => {
    setQualificationmodal(true);
  };
  const handlequalificationClose = () => {
    setQualificationmodal(false);
    setEmpInstitutions("");
    setEmpInsfromdate("");
    setEmpInstodate("");
    setEmpInstdegree("");
    setEmpInstsubject("");
    setInsdocument("");
  };

  const [empInstitutions, setEmpInstitutions] = useState("");
  const [err_empInstitutions, setErr_empInstitutions] = useState("");

  const [empInsfromdate, setEmpInsfromdate] = useState("");
  const [err_empInsfromdate, setErr_empInsfromdate] = useState("");

  const [empInstodate, setEmpInstodate] = useState("");
  const [err_empInstodate, setErr_empInstodate] = useState("");

  const [empInstdegree, setEmpInstdegree] = useState("");
  const [err_empInstdegree, setErr_empInstdegree] = useState("");

  const [empInstsubject, setEmpInstsubject] = useState("");
  const [err_empInstsubject, setErr_empInstsubject] = useState("");

  const [insdocument, setInsdocument] = useState("");
  const [err_insdocument, setErr_insdocument] = useState("");

  const [addmorequalification, setAddmorequalification] = useState([]);
  const handleAddQualification = () => {
    const regexText = /^[a-zA-Z0-9 .,]+$/;
    const documentRegex = /\.(pdf|jpg|jpeg|png)$/i;
    setErr_empInstitutions("");
    setErr_empInsfromdate("");
    setErr_empInstodate("");
    setErr_empInstdegree("");
    setErr_empInstsubject("");
    setErr_insdocument("");
    if (!regexText.test(empInstitutions.trim())) {
      setErr_empInstitutions("required");
      return false;
    }
    if (
      empInsfromdate == "" ||
      empInsfromdate == null ||
      empInsfromdate == undefined
    ) {
      setErr_empInsfromdate("required");
      return false;
    }
    if (
      empInstodate == "" ||
      empInstodate == null ||
      empInstodate == undefined
    ) {
      setErr_empInstodate("required");
      return false;
    }
    if (!regexText.test(empInstdegree.trim())) {
      setErr_empInstdegree("required");
      return false;
    }
    if (!regexText.test(empInstsubject.trim())) {
      setErr_empInstsubject("required");
      return false;
    }
    if (!documentRegex.test(insdocument.name)) {
      setErr_insdocument("required");
      return false;
    } else {
      const user_login_id = localStorage.getItem("userId");
      const date = new Date();
      const createdDatte = format(date, "yyyy-MM-dd HH:m:SS");

      const unic_number = generateUniqueFourDigit();

      const morequalification = {
        id: user_login_id,
        ins_name: empInstitutions,
        fromyear: new Date(empInsfromdate).getFullYear(),
        toyear: new Date(empInstodate).getFullYear(),
        degree: empInstdegree,
        subject: empInstsubject,
        insdocument: insdocument,
        unic_number: unic_number,
        createdOn: createdDatte,
      };
      // const formData = new FormData();
      //  formData.append(`qlf_doc_${unic_number}`, insdocument);

      setAddmorequalification((prevRecords) => [
        ...prevRecords,
        morequalification,
      ]);
    }
  };
  const handleUploadDocument = (e) => {
    const empinstitutedocument = e.target.files[0];
    setErr_insdocument("");
    if (empinstitutedocument) {
      if (empinstitutedocument.size > 2 * 1024 * 1024) {
        setErr_insdocument("File must be less than 2MB");
        e.target.value = ""; // reset input
        return;
      }
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (!allowedTypes.includes(empinstitutedocument.type)) {
        setErr_insdocument("Allowed Only PDF, JPG, and PNG files");
        e.target.value = ""; // reset input
        return;
      }
      setInsdocument(empinstitutedocument);
    }
  };

  function generateUniqueFourDigit() {
    const usedNumbers = new Set();
    if (usedNumbers.size >= 9000) {
      throw new Error("All 4-digit numbers used up!");
    }

    let num;
    do {
      num = Math.floor(1000 + Math.random() * 9000);
    } while (usedNumbers.has(num));

    usedNumbers.add(num);
    return num;
  }

  const removeQualification = (index) => {
    setAddmorequalification((prev) => prev.filter((_, i) => i !== index));
  };

  const [previousCompanymodal, setPreviousCompanymodal] = useState(false);
  const handlePreviousCompanyModal = () => {
    setPreviousCompanymodal(true);
  };

  const handlePreviousCompanyModalClose = () => {
    setPreviousCompanymodal(false);
    setComname("");
    setTitleOfpostion("");
    setNameOfsupervisor("");
    setNumberOfsupervisor("");
    setEmpFromDate("");
    setEmpToDate("");
    setEmpctc("");
    setCmpadd("");
    setReasonLeaving("");
    setUploadedRelivingLetter("");
  };
  const [empExp, setEmpExp] = useState([]);
  const [err_company, setErr_company] = useState("");
  const [err_position, setErr_position] = useState("");
  const [err_supervisor, setErr_supervisor] = useState("");
  const [err_supervisor_number, setErr_supervisor_number] = useState("");
  const [err_empfromdate, setErr_empfromdate] = useState("");
  const [err_emptodate, setErr_emptodate] = useState("");
  const [err_empctc, setErr_empctc] = useState("");
  const [err_cmpadd, setErr_cmpadd] = useState("");
  const [err_appointmentfile, setErr_appointmentfile] = useState("");
  const [err_releavingfile, setErr_releavingfile] = useState("");

  const [comname, setComname] = useState("");
  const [titleOfposition, setTitleOfpostion] = useState("");
  const [nameOfsupervisor, setNameOfsupervisor] = useState("");
  const [numberOfsupervisor, setNumberOfsupervisor] = useState("");
  const [empFromDate, setEmpFromDate] = useState("");
  const [empToDate, setEmpToDate] = useState("");
  const [empctc, setEmpctc] = useState("");
  const [cmpadd, setCmpadd] = useState("");
  const [reasonLeaving, setReasonLeaving] = useState("");
  const [uploadedRelivingLetter, setUploadedRelivingLetter] = useState("");
  const [uploadedUppointmentLetter, setUploadedUppointmentLetter] =
    useState("");
  function validateFile(file) {
    setErr_appointmentfile("");
    const allowedExtensions = /\.(jpg|jpeg|png|pdf|docx)$/i;
    const maxSizeInMB = 2;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (!file || file === null || file === undefined) {
      return {
        valid: false,
        message: "No file selected.",
      };
    }
    if (!allowedExtensions.test(file.name)) {
      return {
        valid: false,
        message: "Allowed: jpg, jpeg, png, pdf, docx",
      };
    }

    if (file.size > maxSizeInBytes) {
      return { valid: false, message: `File size exceeds ${maxSizeInMB}MB` };
    }

    return { valid: true, message: "File is valid" };
  }
  const handleReleavingLetterUpload = (e) => {
    const fileRelivingLetter = e.target.files[0];

    setErr_releavingfile("");
    if (fileRelivingLetter) {
      if (fileRelivingLetter.size > 2 * 1024 * 1024) {
        setErr_releavingfile("File must be less than 2MB");
        e.target.value = ""; // reset input
        return;
      }
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (!allowedTypes.includes(fileRelivingLetter.type)) {
        setErr_releavingfile("Allowed Only PDF, JPG, and PNG files");
        e.target.value = ""; // reset input
        return;
      }
      setUploadedRelivingLetter(fileRelivingLetter);
    }
  };

  const handleAppointmentLetterUpload = (e) => {
    const file = e.target.files[0];
    setErr_appointmentfile("");
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setErr_appointmentfile("File must be less than 2MB");
        e.target.value = ""; // reset input
        return;
      }
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        setErr_appointmentfile("Allowed Only PDF, JPG, and PNG files");
        e.target.value = ""; // reset input
        return;
      }
      setUploadedUppointmentLetter(file);
    }
  };
  const addRecord = () => {
    setErr_company("");
    setErr_position("");
    setErr_supervisor("");
    setErr_supervisor_number("");
    setErr_empfromdate("");
    setErr_emptodate("");
    setErr_empctc("");
    setErr_cmpadd("");
    setErr_appointmentfile("");
    setErr_releavingfile("");

    const regexText = /^[a-zA-Z0-9 ]+$/;
    const regexPhone = /^\d{6,15}$/;
    const regexnumber = /^(\d+\.?\d*|\.\d+)$/;
    const regex_add = /^[a-zA-Z0-9\s.,\-\/#()'&]+$/;
    if (!regexText.test(comname.trim())) {
      setErr_company("required");
      return false;
    }

    if (!regexText.test(titleOfposition.trim())) {
      setErr_position("required");
      return false;
    }

    if (!regexText.test(nameOfsupervisor.trim())) {
      setErr_supervisor("required");
      return false;
    }

    if (!regexPhone.test(numberOfsupervisor.trim())) {
      setErr_supervisor_number("required");
      return false;
    }
    if (empFromDate == "") {
      setErr_empfromdate("required");
      return false;
    }
    if (empToDate == "") {
      setErr_emptodate("required");
      return false;
    }
    if (!regexnumber.test(empctc.trim())) {
      setErr_empctc("required");
      return false;
    }
    if (!regex_add.test(cmpadd.trim())) {
      setErr_cmpadd("required");
      return false;
    } else {
      const file_rel = relavingLetterRef.current?.files[0];
      const result2 = validateFile(file_rel);
      if (!result2.valid) {
        setErr_releavingfile(result2.message);
        return false;
      }

      const file = appointmentLetterRef.current?.files[0];
      const result1 = validateFile(file);
      if (!result1.valid) {
        setErr_appointmentfile(result1.message);
        return false;
      }

      const user_login_id = localStorage.getItem("userId");
      const date = new Date();
      const createdDatte = format(date, "yyyy-MM-dd HH:m:SS");

      const unic_number = generateUniqueFourDigit();

      const employment = {
        comname: comname,
        titleOfposition: titleOfposition,
        nameOfsupervisor: nameOfsupervisor,
        numberOfsupervisor: numberOfsupervisor,
        empFromDate: empFromDate,
        empToDate: empToDate,
        empctc: empctc,
        cmpadd: cmpadd,
        reasonLeaving: reasonLeaving,
        uploadedRelivingLetter: uploadedRelivingLetter,
        uploadedUppointmentLetter: uploadedUppointmentLetter,
        unic_number: unic_number,
        createdOn: createdDatte,
        createdBy: user_login_id,
      };
      setEmpExp((pre) => [...pre, employment]);
    }
  };
  const deleteEmpPreviousComp = (index) => {
    setEmpExp((prev) => prev.filter((_, i) => i !== index));
  };

  const [empslipfile1, setEmpslipfile1] = useState("");
  const [empslipfile2, setEmpslipfile2] = useState("");
  const [empslipfile3, setEmpslipfile3] = useState("");
  const handleSalarySlipOne = (e) => {
    const file = e.target.files[0];
    setEmpslipfile1(file);
  };

  const handleSalarySlipTwo = (e) => {
    const file = e.target.files[0];
    setEmpslipfile2(file);
  };

  const handleSalarySlipThree = (e) => {
    const file = e.target.files[0];
    setEmpslipfile3(file);
  };

  return (
    <>
      <div className="page-header">
        <h1>Add Employee</h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>Employee List{" "}
            </Link>
          </li>
          <li className="current">
            <span>/</span>Add Employee
          </li>
        </ul>
      </div>

      <div className="row_bg">
        <div className="profile_wrapper mb30">
          <div
            className="nav"
            id="profile-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <Link
              className={`nav-link ${emp_profile ? "active" : ""}`}
              onClick={(e) => {
                handleTab(1);
              }}
            >
              Employment Profile
            </Link>
            <span className="middleline"></span>
            <Link
              className={`nav-link ${emp_spc ? "active" : ""}`}
              onClick={(e) => {
                handleTab(2);
              }}
            >
              Employment Detail
            </Link>
            <span className="middleline"></span>
            <Link
              className={`nav-link ${emp_dtl ? "active" : ""}`}
              onClick={(e) => {
                handleTab(3);
              }}
            >
              Bank Detail
            </Link>

            <span className="middleline"></span>
            <Link
              className={`nav-link ${emp_family ? "active" : ""}`}
              onClick={(e) => {
                handleTab(4);
              }}
            >
              Family & Qualification Detail
            </Link>

            <span className="middleline"></span>
            <Link
              className={`nav-link ${emp_previous ? "active" : ""}`}
              onClick={(e) => {
                handleTab(5);
              }}
            >
              Previous Employment Detail
            </Link>
          </div>
          <div className="tab-content" id="profile-tabContent">
            <div
              className={`tab-pane fade ${emp_profile ? "show active" : ""}`}
              id="employmentprofile"
              role="tabpanel"
              aria-labelledby="employmentprofile-tab"
            >
              <div className="tab_content">
                <div className="tab_sub_ttl">Organization</div>

                <div className="row mb25">
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Company <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <span
                          className="error_mgs1"
                          style={{ color: err }}
                        ></span>
                        <select
                          style={{ borderColor: `${errMsgcompany}` }}
                          ref={companyRef}
                          value={company ?? ""}
                          onChange={HandleCompany}
                          className="form-select"
                        >
                          <option value="">Select Company</option>
                          {comdata?.map((item, ind) => (
                            <option key={ind} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        {" "}
                        Division <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <span
                          className="error_mgs1"
                          style={{ color: err }}
                        ></span>
                        <select
                          style={{ borderColor: `${errrole}` }}
                          ref={deptRef}
                          value={department ?? ""}
                          onChange={(e) => handleDepartment(e.target.value)}
                          className="form-select"
                        >
                          <option value="">Select Division </option>
                          {depdata?.map((item, ind) => (
                            <option key={ind} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  {sub_dept_status == "block" && (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">
                          Department <sup className="error_mgs"> *</sup>
                        </div>
                        <div className="form-input col-md-8 addnew_wrapper relative">
                          <select
                            style={{ borderColor: `${errdesignation}` }}
                            ref={designationjRef}
                            value={designation ?? ""}
                            onChange={handleDegination}
                            className="form-select ucwords"
                          >
                            <option value="">Select Department </option>
                            {roledata?.map((item, ind) => (
                              <option key={ind} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>

                          <button
                            className="addnew_btn"
                            onClick={handleAddSubRole}
                          >
                            {" "}
                            Add
                          </button>
                          <div
                            className="error_mgs1"
                            style={{ color: err }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  )}
                  {sub_dept_status == "none" && (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4"> Department</div>
                        <div className="form-input col-md-8 addnew_wrapper1">
                          <input
                            style={{ borderColor: `${errsubrole}` }}
                            type="text"
                            value={newSubrole ?? ""}
                            onChange={(e) => setNewSubrole(e.target.value)}
                            placeholder="Enter Sub Department"
                            className="form-control form-control1"
                          />
                          <button
                            className="addnew_btn1"
                            onClick={handleSaveSubRole}
                          >
                            {" "}
                            Save
                          </button>
                          <button
                            className="cancelnew_btn"
                            onClick={handleCancelSubRole}
                          >
                            {" "}
                            Cancel
                          </button>
                          <div style={{ color: "red" }}>{errcheckrole}</div>
                        </div>
                      </div>
                    </div>
                  )}
                  {skill_status == "block" && (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">
                          Skills <sup className="error_mgs"> *</sup>
                        </div>
                        <div className="form-input col-md-8 addnew_wrapper relative">
                          <span className="error_mgs1"></span>
                          <select
                            ref={skillRef}
                            style={{ borderColor: `${errSkill}` }}
                            value={skill ?? ""}
                            className="form-select"
                            onChange={(e) => setSkill(e.target.value)}
                          >
                            <option value="">Select Skills</option>
                            {skillList?.map((item, i) => (
                              <option value={item.id} key={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          <button
                            className="addnew_btn"
                            onClick={handleAddSkill}
                          >
                            {" "}
                            Add
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {skill_status == "none" && (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4"> Skills</div>
                        <div className="form-input col-md-8 addnew_wrapper1">
                          <input
                            style={{ borderColor: `${errskill}` }}
                            type="text"
                            value={newSkill ?? ""}
                            onChange={(e) => setNewSkill(e.target.value)}
                            placeholder="Enter skills"
                            className="form-control form-control1"
                          />
                          <button
                            className="addnew_btn1"
                            onClick={handleSaveSkill}
                          >
                            {" "}
                            Save
                          </button>
                          <button
                            className="cancelnew_btn"
                            onClick={handleCancelSkill}
                          >
                            {" "}
                            Cancel
                          </button>
                          <div style={{ color: "red" }}>{errcheckskill}</div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Employment Mode <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <span className="error_mgs1"></span>
                        <select
                          style={{ borderColor: `${errMsgempcat}` }}
                          ref={empcatRef}
                          value={empcategory ?? ""}
                          onChange={handlePayRole}
                          className="form-select"
                        >
                          <option value="">Select Employment Mode</option>
                          <option value="1">Payroll</option>
                          <option value="2">Contract</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        System Role <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <span
                          className="error_mgs1"
                          style={{ color: err }}
                        ></span>
                        <select
                          style={{ borderColor: `${errMsgsysRole}` }}
                          ref={systemRoleRef}
                          className="form-select"
                          onChange={HandleSystemRole}
                        >
                          <option value="">Select System Role</option>
                          {system_role?.map((item, ind) => (
                            <option key={ind} value={item.id}>
                              {item.role}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab_sub_ttl">Basic Info</div>
                <div className="row mb25">
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Salutation <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <span className="error_mgs1"></span>
                        <select
                          style={{ borderColor: `${errMsgsalutaion}` }}
                          ref={salutationRef}
                          value={salutation ?? ""}
                          onChange={(e) => {
                            setSalutation(e.target.value);
                          }}
                          className="form-select"
                        >
                          <option value="">Select</option>
                          <option value="1">Mr</option>
                          <option value="2">Ms</option>
                          <option value="3">Mrs</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        First Name <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <input
                          style={{ borderColor: `${errMsgfname}` }}
                          ref={fnameRef}
                          autoComplete="none"
                          value={fname ?? ""}
                          onChange={(e) => {
                            setFname(e.target.value);
                          }}
                          type="text"
                          placeholder="Enter First Name"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Middle Name</div>
                      <div className="form-input col-md-8">
                        <input
                          autoComplete="none"
                          value={mname}
                          onChange={(e) => {
                            setMname(e.target.value);
                          }}
                          type="text"
                          placeholder="Enter Middle Name"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Last Name</div>
                      <div className="form-input col-md-8">
                        <input
                          autoComplete="none"
                          value={lname}
                          onChange={(e) => {
                            setLname(e.target.value);
                          }}
                          type="text"
                          placeholder="Enter Last Name"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Personal Email <sup className="error_mgs"> * </sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <input
                          style={{ borderColor: `${errMsgpersona_email}` }}
                          ref={peremailRef}
                          autoComplete="none"
                          value={persona_email}
                          onChange={HandlePerEmail}
                          type="text"
                          placeholder="Enter Personal Email"
                          className="form-control form-control1 lowercase"
                        />
                        <div className="error_mgs">{checkemail}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Alternate Email</div>
                      <div className="form-input col-md-8 relative">
                        <input
                          type="text"
                          placeholder="Enter Alternate Email"
                          className="form-control form-control1 lowercase"
                          onChange={(e) => setAltemail(e.target.value)}
                          value={altemail}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Contact Number </div>
                      <div className="form-input col-md-8 countrycode_wrp">
                        <select
                          className="form-select"
                          onChange={(e) => setCountrycode(e.target.value)}
                        >
                          <option value="">Select</option>
                          {complist.map((item, i) => (
                            <option key={i} value={item.id}>
                              {item.phonecode}
                            </option>
                          ))}
                        </select>
                        <input
                          autoComplete="none"
                          value={contact_number}
                          onChange={handleChangeNumber}
                          type="text"
                          placeholder="Enter Contact Number"
                          className="form-control form-control1 only-numeric"
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Official Email </div>
										<div className="form-input col-md-8">
											<input checked={officialemailstatus ? 'checked' : ''} onChange={handleEmail} onc type="checkbox" /> Create Yes/No
										</div>
									</div>
								</div>
								</div> */}
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Father/Husband</div>
                      <div className="form-input col-md-8">
                        <input
                          value={gargen}
                          autoComplete="none"
                          onChange={(e) => {
                            setGargen(e.target.value);
                          }}
                          type="text"
                          placeholder="Enter Father/Husband Name"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                  {country == 1 ? (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">Gender</div>
                        <div className="form-input col-md-8">
                          <select
                            value={gender}
                            onChange={(e) => {
                              setGender(e.target.value);
                            }}
                            className="form-select"
                          >
                            <option value="">Select Gender</option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {country == 1 ? (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">
                          Date Of Birth <sup className="error_mgs"> *</sup>
                        </div>
                        <div className="form-input col-md-8 relative">
                          <input
                            style={{ borderColor: `${errMsgdateofbirth}` }}
                            ref={dobRef}
                            onChange={(e) => {
                              setDateofbirth(e.target.value);
                            }}
                            type="date"
                            className="form-control"
                            name=""
                            value={dateofbirth}
                            placeholder="Select Date Of Birth"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {country == 1 ? (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">
                          Marital Status :{marriage}
                        </div>
                        <div className="form-input col-md-8">
                          <select
                            value={marriage}
                            onChange={(e) => setMarriage(e.target.value)}
                            className="form-select"
                          >
                            <option value="">Select Marital Status</option>
                            <option value="1">Married</option>
                            <option value="2">Unmarried</option>
                            <option value="3">Other</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {marriage == 1 && (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">
                          Anniversary Date
                        </div>
                        <div className="form-input col-md-8 relative">
                          <input
                            value={dateofwedding}
                            onChange={(e) => {
                              setDateofwedding(e.target.value);
                            }}
                            type="date"
                            className="form-control"
                            name=""
                            placeholder=""
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {country == 1 ? (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">Blood Group</div>
                        <div className="form-input  col-md-8">
                          <input
                            type="text"
                            value={bloodgroup}
                            onChange={(e) => setBloodgroup(e.target.value)}
                            placeholder="Enter Blood Group"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* <div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Country</div>
											<div className="form-input col-md-8">

												<input type="text" value={nationality} onChange={(e) => setNationality(e.target.value)} placeholder="Enter Country" className="form-control form-control1" />
											</div>
										</div>
									</div> */}

                  {/* <div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Aadhaar Name </div>
											<div className="form-input col-md-8">
												<input type="text" value={adhaarname} onChange={(e) => setAdhaarname(e.target.value)} placeholder="Enter Aadhaar Card Name" className="form-control form-control1" />
											</div>
										</div>
									</div> */}
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Hobbies </div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          placeholder="Enter Hobbies"
                          className="form-control form-control1"
                          onChange={(e) => setHobbies(e.target.value)}
                          value={hobbies}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Weight <sup>( Kg )</sup>{" "}
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          placeholder="Enter Weight"
                          className="form-control form-control1"
                          onChange={(e) => setWeight(e.target.value)}
                          value={weight}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Height <sup>( inches )</sup>{" "}
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          placeholder="Enter Height"
                          className="form-control form-control1"
                          onChange={(e) => setHeight(e.target.value)}
                          value={height}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Nationality </div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          placeholder="Enter Nationality"
                          className="form-control form-control1"
                          value={nationality}
                          onChange={(e) => setNationality(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  {country == 1 ? (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">
                          Aadhaar Number
                        </div>
                        <div className="form-input col-md-8">
                          <input
                            type="text"
                            value={adhaarnumber}
                            onChange={HandleAdhaar}
                            placeholder="Enter Aadhaar Card Number"
                            className="form-control form-control1 only-numeric"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Upload Aadhaar Card
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          type="file"
                          className="form-control uploadbtn"
                          onChange={handleAadharCard}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        {country == 1 ? "Pan Number" : "SSN"}
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          value={pancardnumber}
                          onChange={(e) =>
                            setPancardnumber(e.target.value.toUpperCase())
                          }
                          type="text"
                          placeholder={`Enter ${
                            country == 1 ? "Pan Number" : "SSN"
                          }`}
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Upload Pan Card</div>
                      <div className="form-input col-md-8">
                        <input
                          type="file"
                          name="filepancard"
                          className="form-control uploadbtn"
                          onChange={handlePancard}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Upload passport</div>
                      <div className="form-input col-md-8">
                        <input
                          type="file"
                          name="passportnumber"
                          className="form-control uploadbtn"
                          onChange={handlePassportnumber}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Photograph <sup>( Passport size )</sup>
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          type="file"
                          name="passportsize"
                          className="form-control uploadbtn"
                          onChange={handlePhotoGraph}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Upload Address Proof
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          type="file"
                          name=""
                          className="form-control uploadbtn"
                          onChange={handleAddressProof}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab_sub_ttl">Location</div>
                <div className="row mb25">
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Country</div>
                      <div className="form-input col-md-8">
                        <select
                          disabled
                          value={country}
                          onChange={handleCountry}
                          className="form-select"
                        >
                          <option value="">Select Country</option>
                          {countrylist.map((item, ind) => {
                            return (
                              <option key={ind} value={item.id}>
                                {item.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Time Zone <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <select
                          style={{ borderColor: `${errMsgTimezone}` }}
                          ref={timezoneRef}
                          value={timezone}
                          onChange={(e) => setTimezone(e.target.value)}
                          className="form-select"
                          placeholder="Select Time Zone"
                        >
                          <option value="">Select Time Zone</option>
                          {locationlist?.map((item, ind) => (
                            <option
                              key={item.location_id}
                              value={item.location_id}
                            >
                              {item.name} {item.timezone}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">State</div>
                      <div className="form-input col-md-8">
                        <select
                          style={{ borderColor: `${errstate}` }}
                          value={state}
                          onChange={HandleState}
                          className="form-select"
                        >
                          <option value="">Select State</option>
                          {statelist.map((item, ind) => {
                            return (
                              <option key={ind} value={item.id}>
                                {item.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                  {location_status == "block" && (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">Work Location</div>
                        <div className="form-input col-md-8 addnew_wrapper">
                          <select
                            className="form-select"
                            onChange={(e) => {
                              setWorkplace(e.target.value);
                            }}
                          >
                            <option value="">Select Work Location</option>
                            {workLocationlist.map((item, ind) => {
                              return (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                          <button
                            className="addnew_btn"
                            onClick={handleWorkLocation}
                          >
                            {" "}
                            Add New
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {location_status == "none" && (
                    <div className="col-md-6">
                      <div className="form-blk row mb25">
                        <div className="form-label col-md-4">Work Location</div>
                        <div className="form-input col-md-8 addnew_wrapper1">
                          <input
                            ref={newworklocationRef}
                            style={{ borderColor: `${errwrklsn}` }}
                            type="text"
                            value={newworklocation}
                            onChange={(e) => setNewworklocation(e.target.value)}
                            placeholder="Enter work location"
                            className="form-control form-control1"
                          />
                          <button
                            className="addnew_btn1"
                            onClick={handleSaveLocation}
                          >
                            {" "}
                            Save
                          </button>
                          <button
                            className="cancelnew_btn"
                            onClick={handleCancellocation}
                          >
                            {" "}
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Shift Time <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <select
                          style={{ borderColor: `${errMsgShift}` }}
                          ref={empshiftRef}
                          value={shift}
                          className="form-select"
                          onChange={(e) => {
                            setShift(e.target.value);
                          }}
                        >
                          <option value="">Select Shift</option>
                          {shiftList.map((item, ind) => {
                            return (
                              <option key={item.id} value={item.id}>
                                {item.Name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab_sub_ttl">Emergency Contact</div>
                <div className="row mb25">
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Person</div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          placeholder="Enter Person"
                          className="form-control form-control1"
                          onChange={(e) =>
                            setEmercontactpersion(e.target.value)
                          }
                          value={emercontactpersion}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Person Relationship
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          placeholder="Enter person Relationship"
                          className="form-control form-control1"
                          onChange={(e) =>
                            setEmercontactrelation(e.target.value)
                          }
                          value={emercontactrelation}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Phone Number</div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          placeholder="Enter Phone Number"
                          className="form-control form-control1"
                          onChange={(e) =>
                            setEmercontactnumber(
                              e.target.value.replace(/\D/g, ""),
                            )
                          }
                          value={emercontactnumber}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab_sub_ttl mb00">Address</div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-blk mb10">
                      <div className="form-label">Current Address</div>
                      <div className="form-input  ">
                        <textarea
                          onChange={(e) => setcurrenAdd(e.target.value)}
                          className="form-control"
                          name=""
                          value={currenAdd}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk mb10">
                      <div className="form-label">Permanent Address</div>
                      <div className="form-input  ">
                        <textarea
                          onChange={(e) => setPermanentaddress(e.target.value)}
                          className="form-control form-control1"
                          value={permanentaddress}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`tab-pane fade ${emp_spc ? "show active" : ""}`}
              id="employmentspecifics"
              role="tabpanel"
              aria-labelledby="employmentspecifics-tab"
            >
              <div className="tab_content">
                <div className="tab_sub_ttl">Employee Details</div>
                <div className="row mb25">
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Employee Code</div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          value={empCode ?? ""}
                          readOnly
                          placeholder="Enter Employee Code"
                          className="form-control form-control1"
                        />
                        {/* <div style={{ color: 'red' }}>{checkempcode > 0 ? 'User Code already exist' : ''}</div> */}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Employee Status</div>
                      <div className="form-input col-md-8">
                        <select
                          value={empstatus}
                          onChange={(e) => setEmpstatus(e.target.value)}
                          className="form-select"
                        >
                          <option value="">Select Employee Status</option>
                          <option value="1">Active</option>
                          <option value="2">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Date of joining <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 relative">
                        <input
                          style={{ borderColor: `${errMsgdateofjoining}` }}
                          ref={dofjRef}
                          type="date"
                          value={dateofjoining}
                          onChange={HandleDateOfJoining}
                          className="form-control"
                          placeholder="Select Date of joining"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4 pr07">
                        Probation Period (Month)
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          onChange={(e) =>
                            setProbation_period(
                              e.target.value.replace(/\D/g, ""),
                            )
                          }
                          value={probation_period}
                          placeholder="Enter Probation Period (month)"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Confirmation Date
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          value={confirmationdate}
                          onChange={HandleConfirmationDate}
                          type="date"
                          className="form-control"
                          placeholder="Select Confirmation Date"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4 pr07">
                        Notice Period (Days){" "}
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          value={noticeperiod}
                          onChange={(e) =>
                            setNoticeperiod(e.target.value.replace(/\D/g, ""))
                          }
                          type="text"
                          placeholder="Enter Notice Period"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        First Reporting{" "}
                      </div>
                      <div className="form-input col-md-8">
                        {/* <select value={reportingmanager} className="form-select" onChange={(e) => { setreportingmanager(e.target.value) }}>
													<option value=''>Select Reporting</option>
													{
														reportimgManageList.map((item, ind) => {
															return <option value={item.id}>{item.name}</option>
														})
													}
												</select> */}
                        {/* <Select options={reporting_option} /> */}
                        <Select
                          onChange={(e) => {
                            setreportingmanager(e.value);
                          }}
                          options={reporting_option}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Final Reporting{" "}
                      </div>
                      <div className="form-input col-md-8">
                        {/* <div className="form-check formcheck1">
													<input className="form-check-input" type="checkbox" value="" id="level1" />
													<label className="form-check-label" htmlFor="level1">
														Level 1
													</label>
												</div>
												<div className="form-check formcheck1">
													<input className="form-check-input" type="checkbox" value="" id="level2" />
													<label className="form-check-label" htmlFor="level2">
														Level 2
													</label>
												</div> */}
                        {/* <select value={finalReport} className="form-select" onChange={(e) => { setFinalReport(e.target.value) }}>
													<option value=''>Select Reporting</option>
													{
														 finalReportList.map((item, ind) => {
															return <option value={item.id}>{item.name}</option>
														})
													}
												</select> */}
                        <Select
                          onChange={(e) => {
                            setFinalReport(e.value);
                          }}
                          options={finalreport_option}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab_sub_ttl">Skill</div>
                <div className="row mb25">
                  <div className="col-md-6">
                    <div className="form-blk mb10">
                      <div className="form-label">Computer Skills</div>
                      <div className="form-input  ">
                        <textarea
                          className="form-control"
                          onChange={(e) => setComputerSkills(e.target.value)}
                          value={computerSkills ?? ""}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk mb10">
                      <div className="form-label">
                        Other Skills / Certifications
                      </div>
                      <div className="form-input">
                        <textarea
                          className="form-control form-control1"
                          onChange={(e) => setOtherSkills(e.target.value)}
                          value={otherSkills ?? ""}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab_sub_ttl">Languages</div>
                <table className="monthly_table mt20">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Speak</th>
                      <th>Read</th>
                      <th>Write</th>
                      <th>Understand</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>English</td>
                      <td>
                        <select
                          className="form-select"
                          onChange={(e) => setSpeak1(e.target.value)}
                          value={speak1 ?? ""}
                        >
                          <option value="">Select Level</option>
                          <option value="1">Level I</option>
                          <option value="2">Level II</option>
                          <option value="3">Level III</option>
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-select"
                          onChange={(e) => setRead1(e.target.value)}
                          value={read1 ?? ""}
                        >
                          <option value="">Select Level</option>
                          <option value="1">Level I</option>
                          <option value="2">Level II</option>
                          <option value="3">Level III</option>
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-select"
                          onChange={(e) => setWrite1(e.target.value)}
                          value={write1 ?? ""}
                        >
                          <option value="">Select Level</option>
                          <option value="1">Level I</option>
                          <option value="2">Level II</option>
                          <option value="3">Level III</option>
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-select"
                          onChange={(e) => setUnderstand1(e.target.value)}
                          value={understand1 ?? ""}
                        >
                          <option value="">Select Level</option>
                          <option value="1">Level I</option>
                          <option value="2">Level II</option>
                          <option value="3">Level III</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td>Hindi</td>
                      <td>
                        <select
                          className="form-select"
                          onChange={(e) => setSpeak2(e.target.value)}
                          value={speak2 ?? ""}
                        >
                          <option value="">Select Level</option>
                          <option value="1">Level I</option>
                          <option value="2">Level II</option>
                          <option value="3">Level III</option>
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-select"
                          onChange={(e) => setRead2(e.target.value)}
                          value={read2 ?? ""}
                        >
                          <option value="">Select Level</option>
                          <option value="1">Level I</option>
                          <option value="2">Level II</option>
                          <option value="3">Level III</option>
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-select"
                          onChange={(e) => setWrite2(e.target.value)}
                          value={write2 ?? ""}
                        >
                          <option value="">Select Level</option>
                          <option value="1">Level I</option>
                          <option value="2">Level II</option>
                          <option value="3">Level III</option>
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-select"
                          onChange={(e) => setUnderstand2(e.target.value)}
                          value={understand2 ?? ""}
                        >
                          <option value="">Select Level</option>
                          <option value="1">Level I</option>
                          <option value="2">Level II</option>
                          <option value="3">Level III</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="4" className="green_mgs">
                        Note : Level I - Limited Knowledge , Level II - Good
                        Working Knowledge , Level III - Expertise
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              className={`tab-pane fade ${emp_dtl ? "show active" : ""}`}
              id="detail"
              role="tabpanel"
              aria-labelledby="detail-tab"
            >
              <div className="tab_content">
                <div className="tab_sub_ttl">Remuneration</div>
                <div className="row mb25">
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Salary Type</div>
                      <div className="form-input col-md-8">
                        <select
                          className="form-select"
                          value={salaryType ?? ""}
                          onChange={(e) => {
                            setSalaryType(e.target.value);
                          }}
                        >
                          <option value="">Select Salary Type</option>
                          <option value="1">Monthly Basis</option>
                          <option value="2">Daily Basis</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">CTC</div>
                      <div className="form-input col-md-8">
                        <input
                          value={ctc ?? ""}
                          onChange={(e) => setCtc(e.target.value)}
                          type="text"
                          placeholder="Enter CTC"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab_sub_ttl">Bank Details</div>
                <div className="row mb25">
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Salary Bank</div>
                      <div className="form-input col-md-8">
                        <select
                          value={bankname}
                          onChange={(e) => setBankname(e.target.value)}
                          className="form-select"
                        >
                          <option value="">Select Salary Type</option>
                          <option value="1">HDFC Bank</option>
                          <option value="2">Federal Bank</option>
                          <option value="3">IDFC FIRST Bank</option>
                          <option value="4">RBL Bank</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Account Number</div>
                      <div className="form-input col-md-8">
                        <input
                          value={accountnumber}
                          onChange={(e) => setAccountnumber(e.target.value)}
                          type="text"
                          placeholder="Enter Salary Account Number"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">IFSC Code</div>
                      <div className="form-input col-md-8">
                        <input
                          value={ifsc}
                          onChange={(e) => setIfsc(e.target.value)}
                          type="text"
                          placeholder="Enter Salary IFSC Code"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">PF Applicable</div>
											<div className="form-input col-md-8">
												<select value={pfapplicable} onChange={(e) => setPfapplicable(e.target.value)} className="form-select">
													<option value=''>Select PF Applicable</option>
													<option value='1'>Yes</option>
													<option value='2'>No</option>
												</select>
											</div>
										</div>
									</div> */}
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">PF Number</div>
                      <div className="form-input col-md-8">
                        <input
                          value={pfnumber}
                          onChange={(e) => setPfnumber(e.target.value)}
                          type="text"
                          placeholder="Enter PF Number"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">PF Group</div>
                      <div className="form-input col-md-8">
                        <select
                          value={pfgroup}
                          onChange={(e) => setPfgroup(e.target.value)}
                          className="form-select"
                        >
                          <option value="">Select PF Group</option>
                          <option value="1">Yes</option>
                          <option value="2">No</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">PT Applicable</div>
											<div className="form-input col-md-8">
												<select className="form-select" onChange={(e) => { setPt_applicable(e.target.value) }}>
													<option value=''>Select PT Group</option>
													<option value='1'>Yes</option>
													<option value='2'>No</option>
												</select>
											</div>
										</div>
									</div> */}
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">UAN Number</div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          onChange={(e) => {
                            setUan_number(e.target.value);
                          }}
                          placeholder="Enter UAN Number"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`tab-pane fade ${emp_family ? "show active" : ""}`}
              id="family"
              role="tabpanel"
              aria-labelledby="family-tab"
            >
              <div className="tab_content">
                <button
                  className="btn_5 float-end minus_mt15"
                  // data-bs-toggle="modal"
                  // data-bs-target="#addfamilydetail"
                  onClick={handleShowModal}
                >
                  Add Family Detail
                </button>

                <div className="tab_sub_ttl">Family Detail</div>
                <table className="monthly_table mt20 mb30">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Relationship</th>
                      <th>Age </th>
                      <th>Date of Birth</th>
                      <th>Occupation</th>
                      <th className="text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addmorerecordfamily?.map((record, index) => (
                      <tr key={index}>
                        <td>{record.name}</td>
                        <td>{record.rel}</td>
                        <td>{record.age}</td>
                        <td>
                          {record.dob &&
                            moment(record.dob).format("DD MMM, YYYY")}
                        </td>
                        <td>{record.accupation}</td>
                        <td className="text-right">
                          <button
                            className="btn_8 small_btn"
                            onClick={() => removeRecord(index)}
                          >
                            <i className="icon icon-cross"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  {addmorerecordfamily.length < 1 && (
                    <tbody>
                      <tr>
                        <td colSpan="6" className="text-center">
                          <div className="notfound">No Record found</div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>

                <button
                  className="btn_5 float-end minus_mt15"
                  onClick={handleShowModalqualification}
                >
                  Add Qualification Detail
                </button>
                <div className="tab_sub_ttl">Qualification Detail</div>
                <table className="monthly_table mt20 mb25">
                  <thead>
                    <tr rowSpan="2">
                      <th>Educational Institutions Name</th>
                      <th>From Date</th>
                      <th>To Date</th>
                      <th>Degree / Diploma Major Subjects </th>
                      <th>Major Subjects</th>
                      <th className="text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addmorequalification?.map((item, ind) => (
                      <tr>
                        <td>School</td>
                        <td>2005</td>
                        <td>2006</td>
                        <td>10</td>
                        <td>maths</td>
                        <td className="text-right">
                          {/* <button className="btn_9 mr05">
                            <i className="icon icon-download"></i>
                          </button>
                          <button
                            className="btn_7 mr05"
                            data-bs-toggle="modal"
                            data-bs-target="#educationdetail"
                          >
                            <i className="icon icon-pencil"></i>
                          </button> */}
                          <button
                            className="btn_8 small_btn"
                            onClick={() => removeQualification(ind)}
                          >
                            <i className="icon icon-cross"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div
                  className="modal fade"
                  id="educationdetail"
                  tabIndex="-1"
                  aria-labelledby="educationModalLabel"
                  aria-modal="true"
                  role="dialog"
                >
                  <Modal show={qualificationmodal} size="md">
                    <div className="modal-body">
                      <button
                        type="button"
                        className="float-end btn_close"
                        onClick={handlequalificationClose}
                      >
                        <i className="icon icon-cross"></i>
                      </button>
                      <div
                        className="dash_white_box_ttl text-center"
                        id="educationModalLabel"
                      >
                        Add Qualification Detail
                      </div>
                      <div className="mb-2">
                        <label className="col-form-label">
                          Educational Institutions Name
                          <sup className="error_mgs">
                            * {err_empInstitutions}
                          </sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={empInstitutions}
                          onChange={(e) => setEmpInstitutions(e.target.value)}
                        />
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-6">
                          <label className="col-form-label">
                            From Year{" "}
                            <sup className="error_mgs">
                              * {err_empInsfromdate}
                            </sup>
                          </label>
                          <DatePicker
                            showYearPicker
                            dateFormat="yyyy"
                            className="form-control"
                            minDate={new Date("1980", 0)}
                            maxDate={new Date("2020", 40)}
                            // value={empInsfromdate}
                            onChange={(date) => setEmpInsfromdate(date)}
                            selected={empInsfromdate}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="col-form-label">
                            To Year{" "}
                            <sup className="error_mgs">
                              * {err_empInstodate}
                            </sup>
                          </label>
                          <DatePicker
                            className="form-control"
                            name="to_year"
                            showYearPicker
                            dateFormat="yyyy"
                            selected={empInstodate}
                            onChange={(date) => setEmpInstodate(date)}
                            minDate={new Date("1980", 0)}
                            maxDate={new Date("2020", 40)}
                          />
                        </div>
                      </div>
                      <div className="mb-2">
                        <label className="col-form-label">
                          Degree / Diploma Major Subjects{" "}
                          <sup className="error_mgs">* {err_empInstdegree}</sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="degree_name"
                          value={empInstdegree}
                          onChange={(e) => setEmpInstdegree(e.target.value)}
                        />
                      </div>
                      <div className="mb-2">
                        <label className="col-form-label">
                          Major Subjects{" "}
                          <sup className="error_mgs">
                            * {err_empInstsubject}
                          </sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="subject"
                          value={empInstsubject}
                          onChange={(e) => setEmpInstsubject(e.target.value)}
                        />
                      </div>
                      <div className="mb-4">
                        <label className="col-form-label">
                          Upload Document{" "}
                          <sup className="error_mgs">* {err_insdocument}</sup>
                        </label>
                        <div className="form-input input-group">
                          <input
                            type="file"
                            name="degree_doc"
                            className="form-control uploadbtn"
                            id="degree_doc"
                            onChange={handleUploadDocument}
                          />
                        </div>
                        <span className="notice_text">
                          Allowed file: PDF, JPG, JPEG, PNG (Max size: 2MB)
                        </span>
                      </div>
                      <div className="modalfooter">
                        <button
                          type="button"
                          className="btn_6 float-end ml10"
                          onClick={handlequalificationClose}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn_5 float-end"
                          onClick={handleAddQualification}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </Modal>
                </div>

                <div
                  className="modal fade"
                  id="addfamilydetail"
                  tabIndex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-modal="true"
                  role="dialog"
                >
                  <Modal show={modal} size="md" id="confirm_login">
                    <div className="modal-body">
                      <button
                        type="button"
                        className="float-end btn_close"
                        onClick={handleClose}
                      >
                        <i className="icon icon-cross"></i>
                      </button>
                      <div
                        className="dash_white_box_ttl text-center"
                        id="exampleModalLabel"
                      >
                        Add Family Detail
                      </div>
                      <div className="mb-2">
                        <label className="col-form-label">
                          Name{" "}
                          <sup className="error_mgs">
                            * {err_familymembername}
                          </sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={familymembername}
                          onChange={(e) => setFamilymembername(e.target.value)}
                        />
                      </div>
                      <div className="mb-2">
                        <label className="col-form-label">
                          Relationship{" "}
                          <sup className="error_mgs">
                            * {err_familymemberrelation}
                          </sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="relationship"
                          value={familymemberrelation}
                          onChange={(e) =>
                            setFamilymemberrelation(e.target.value)
                          }
                        />
                      </div>
                      <div className="mb-2 row">
                        <div className="col-md-6">
                          <label className="col-form-label">
                            Date of Birth{" "}
                            <sup className="error_mgs">
                              * {err_familymemberdob}
                            </sup>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="dob"
                            value={familymemberdob}
                            onChange={handleAge}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="col-form-label">Age </label>
                          <input
                            type="text"
                            className="form-control"
                            readOnly
                            value={familymemberage ?? ""}
                          />
                        </div>
                      </div>
                      <div className="mb-4">
                        <label className="col-form-label">
                          Occupation{" "}
                          <sup className="error_mgs">
                            * {err_familymemberaccupation}
                          </sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="occupation"
                          value={familymemberaccupation}
                          onChange={(e) =>
                            setFamilymemberaccupation(e.target.value)
                          }
                        />
                      </div>
                      <div className="modalfooter">
                        <button
                          type="button"
                          className="btn_6 float-end ml10"
                          onClick={handleClose}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn_5 float-end"
                          onClick={addmorefamilyDetails}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
            </div>

            <div
              className={`tab-pane fade ${emp_previous ? "show active" : ""}`}
              id="previous"
              role="tabpanel"
              aria-labelledby="previous-tab"
            >
              <div className="tab_content">
                <button
                  className="btn_5 float-end minus_mt15"
                  onClick={handlePreviousCompanyModal}
                >
                  Add Previous Employment
                </button>
                <div className="tab_sub_ttl">Previous Employment Detail</div>
                <table className="monthly_table mt20 mb25">
                  <thead>
                    <tr rowSpan="2">
                      <th>Company Name</th>
                      <th>Title of Position</th>
                      <th>Name &amp; Phone No. of Supervisor</th>
                      <th>From &amp; Till Date</th>
                      <th>Total CTC including Benefits</th>
                      <th>Address of Employer</th>
                      <th>Reason for Leaving</th>
                      <th className="text-right" style={{ width: "150px" }}>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {empExp?.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No records added yet
                        </td>
                      </tr>
                    ) : (
                      empExp?.map((item, ind) => (
                        <tr key={ind}>
                          <td>{item.comname}</td>
                          <td>{item.titleOfposition}</td>
                          <td>
                            {item.nameOfsupervisor} & {item.numberOfsupervisor}
                          </td>
                          <td>
                            {item.empFromDate} & {item.empToDate}
                          </td>
                          <td>{item.empctc}</td>
                          <td>{item.cmpadd}</td>
                          <td>{item.reasonLeaving}</td>
                          <td className="text-right">
                            <button
                              className="btn_8 small_btn"
                              onClick={() => deleteEmpPreviousComp(ind)}
                            >
                              <i className="icon icon-cross"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="joining_blk">
                  <div className="tab_sub_ttl mb00">
                    Previous Company Salary Slip
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-blk">
                        <div className="form-label">Slip 1</div>
                        <div className="form-input input-group">
                          <input
                            type="file"
                            className="form-control uploadbtn"
                            onChange={handleSalarySlipOne}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk">
                        <div className="form-label">Slip 2</div>
                        <div className="form-input input-group">
                          <input
                            type="file"
                            className="form-control uploadbtn"
                            onChange={handleSalarySlipTwo}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-blk">
                        <div className="form-label">Slip 3</div>
                        <div className="form-input input-group">
                          <input
                            type="file"
                            className="form-control uploadbtn"
                            onChange={handleSalarySlipThree}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="modal fade"
                  id="previouscompanydetail"
                  tabIndex="-1"
                  aria-labelledby="previousModalLabel"
                  role="dialog"
                >
                  <Modal show={previousCompanymodal} size="lg">
                    <div className="modal-body">
                      <button
                        type="button"
                        className="float-end btn_close"
                        onClick={handlePreviousCompanyModalClose}
                      >
                        <i className="icon icon-cross"></i>
                      </button>
                      <div
                        className="dash_white_box_ttl text-center mb10"
                        id="previousModalLabel"
                      >
                        Add Previous Employment Detail
                      </div>
                      <div className="row mb10">
                        <div className="col-md-6">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              Company Name
                              <sup className="error_mgs "> *{err_company}</sup>
                            </div>
                            <div className="form-input">
                              <input
                                value={comname}
                                onChange={(e) => setComname(e.target.value)}
                                type="text"
                                name="company_name"
                                id="company_name"
                                className="form-control form-control1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              Title of Position
                              <sup className="error_mgs "> *{err_position}</sup>
                            </div>
                            <div className="form-input">
                              <input
                                type="text"
                                name="position"
                                id="position"
                                className="form-control form-control1"
                                onChange={(e) =>
                                  setTitleOfpostion(e.target.value)
                                }
                                value={titleOfposition}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              Name of Supervisor
                              <sup className="error_mgs ">
                                {" "}
                                *{err_supervisor}
                              </sup>
                            </div>
                            <div className="form-input">
                              <input
                                type="text"
                                name="supervisor"
                                id="supervisor"
                                className="form-control form-control1"
                                onChange={(e) =>
                                  setNameOfsupervisor(e.target.value)
                                }
                                value={nameOfsupervisor}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              Phone Number of Supervisor
                              <sup className="error_mgs ">
                                *{err_supervisor_number}
                              </sup>
                            </div>
                            <div className="form-input">
                              <input
                                type="text"
                                name="supervisor_mobno"
                                id="supervisor_mobno"
                                className="form-control form-control1"
                                value={numberOfsupervisor}
                                onChange={(e) => {
                                  const onlyNums = e.target.value.replace(
                                    /\D/g,
                                    "",
                                  );
                                  setNumberOfsupervisor(onlyNums);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              From Date
                              <sup className="error_mgs ">
                                *{err_empfromdate}
                              </sup>
                            </div>
                            <div className="form-input">
                              <input
                                type="date"
                                name="from_date"
                                id="from_date"
                                className="form-control form-control1"
                                value={empFromDate}
                                onChange={(e) => setEmpFromDate(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              To Date
                              <sup className="error_mgs ">*{err_emptodate}</sup>
                            </div>
                            <div className="form-input">
                              <input
                                type="date"
                                name="to_date"
                                id="to_date"
                                className="form-control form-control1"
                                value={empToDate}
                                onChange={(e) => setEmpToDate(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              Total CTC including Benefits
                              <sup className="error_mgs ">*{err_empctc}</sup>
                            </div>
                            <div className="form-input">
                              <input
                                type="text"
                                name="total_pre_ctc"
                                id="total_pre_ctc"
                                className="form-control form-control1"
                                value={empctc}
                                onChange={(e) => {
                                  const ctcNum = e.target.value.replace(
                                    /[^0-9]/g,
                                    "",
                                  ); // remove non-digits
                                  setEmpctc(ctcNum);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              Address of Employer
                              <sup className="error_mgs ">*{err_cmpadd}</sup>
                            </div>
                            <div className="form-input">
                              <input
                                value={cmpadd}
                                onChange={(e) => setCmpadd(e.target.value)}
                                type="text"
                                name="address_employer"
                                id="address_employer"
                                className="form-control form-control1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              Reason for Leaving{" "}
                            </div>
                            <div className="form-input">
                              <input
                                value={reasonLeaving}
                                onChange={(e) =>
                                  setReasonLeaving(e.target.value)
                                }
                                type="text"
                                name="reason_leaving"
                                id="reason_leaving"
                                className="form-control form-control1"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              Upload Reliving Letter
                              <sup className="error_mgs ">
                                *{err_releavingfile}
                              </sup>
                            </div>
                            <div className="form-input input-group">
                              <input
                                type="file"
                                onChange={handleReleavingLetterUpload}
                                ref={relavingLetterRef}
                                className="form-control uploadbtn"
                              />
                            </div>
                            <span className="notice_text">
                              Allowed file: PDF, JPG, JPEG, PNG (Max size: 2MB)
                            </span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-blk mb15">
                            <div className="col-form-label">
                              Upload Appointment Letter
                              <sup className="error_mgs ">
                                *{err_appointmentfile}
                              </sup>
                            </div>
                            <div className="form-input input-group">
                              <input
                                type="file"
                                onChange={handleAppointmentLetterUpload}
                                ref={appointmentLetterRef}
                                name="appointment_letter"
                                className="form-control uploadbtn"
                              />
                            </div>
                            <span className="notice_text">
                              Allowed file: PDF, JPG, JPEG, PNG (Max size: 2MB)
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="modalfooter">
                        <button
                          type="button"
                          className="btn_6 float-end ml10"
                          onClick={handlePreviousCompanyModalClose}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn_5 float-end"
                          onClick={addRecord}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
            </div>
            <div className="tab_footer text-end">
              <span className="mr08" style={{ color: color ? color : "" }}>
                {errmsg}
              </span>
              <button
                disabled={save_status}
                style={{ display: buttonstatus == true ? "" : "none" }}
                className="btn_5"
                onClick={(e) => handleAddEMP()}
              >
                Save
              </button>
              <button className="btn_6 ml10">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AddEmployeeCom;
